export default {
  notifPrefs: {
    title: "Preferencias de avisos",
  },
};
